<template>
    <div>
        <div>
            <b-tabs
                active-nav-item-class="font-weight-bold text-light bg-info"
            >
                <b-tab
                    v-for="(item, index) in reg_statsionar_doctor"
                    :key="index"
                    :title="$t('Текшириш')"
                    title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
                    style="padding: 0px !important;"
                >
                    <div class="tek-card">
                        <div>
                            <VueEditorText 
                                :text="item.statsionar_text"
                                :indReg="index"
                                :defaultHeigth="defaultHeigth"
                                @vueEditorText="vueEditorText"
                                @textChangeValueIndex="textChangeValueIndex"
                            />
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import VueEditorText from '../VueEditorText.vue';
export default{
    props: ["reg_statsionar_doctor"],
    components: {
        VueEditorText
    },
    data(){
        return {
            defaultHeigth: "height: 960px;",
            textChangeValue: {
                index: null,
                key: null,
            },
        }
    },
    methods:{
        vueEditorText(val, index, indexChild, textValue){
            this.reg_statsionar_doctor[index].statsionar_text = val;
            // console.log(this.doctor[index].text)
        },
        textChangeValueIndex(key, index){
            this.textChangeValue = {
                index: index,
                key: key,
            }
        },
    }
}
</script>